/** Maps app locale (e.g. react-i18next) to TinyMCE GPL lang packs served from `/tinymce/langs/*.js`. */
export type TinymceUiLocale = {
  language?: string;
  language_url?: string;
  /** For React `key` so UI strings reload when locale changes */
  localeKey: string;
};

export function resolveTinymceUiLocale(i18nLanguage?: string): TinymceUiLocale {
  if (!i18nLanguage?.trim()) {
    return { localeKey: "en" };
  }
  const primary = i18nLanguage.toLowerCase().split("-")[0] ?? "en";
  if (primary === "en") {
    return { localeKey: "en" };
  }

  const map: Record<string, { language: string; file: string }> = {
    nl: { language: "nl", file: "nl.js" },
    de: { language: "de", file: "de.js" },
    es: { language: "es", file: "es.js" },
    fr: { language: "fr-FR", file: "fr-FR.js" },
  };

  const entry = map[primary];
  if (!entry) {
    return { localeKey: "en" };
  }

  return {
    language: entry.language,
    language_url: `/tinymce/langs/${entry.file}`,
    localeKey: entry.language,
  };
}

/** Block style labels in the dropdown — not auto-translated; tie to app locale. */
export function getBlockFormatsForLocale(contentLocale?: string): string {
  const primary =
    contentLocale?.toLowerCase().split("-")[0]?.trim() ?? "en";
  if (primary === "nl") {
    return "Normaal=p; Kop 2=h2; Kop 3=h3; Kop 4=h4";
  }
  return "Normal=p; Heading 2=h2; Heading 3=h3; Heading 4=h4";
}
